import type React from 'react';
import { useSelector } from 'react-redux';

import OngoingRouteBadge from './OngoingRouteBadge';

import type { TimestampInMillis } from '@cobliteam/common-types';

import { isWebDataSuccess } from '@cobliteam/api-lib';

import { selectAddress } from '@cobliteam/store';

import '@cobliteam/base-components';

import {
  TrackingPopUp,
  TrackingPopUpContent,
  TrackingPopUpFooter,
  TrackingPopUpHeader,
  TrackingPopUpHeaderMain,
  TrackingPopUpInfoRowText,
  TrackingPopUpSkeleton,
  TrackingPopUpTitle,
} from '../Tracking/components/Common/TrackingPopUp';
import { EndIconComponent, StartIconComponent } from '../Tracking/components/Map';

import { formatTimestamp } from '../Tracking/utils/date';

export interface StartEndPopupProps {
  times: {
    start?: TimestampInMillis;
    end?: TimestampInMillis;
  };
  isTrackingToday?: boolean;
  driverName?: string;
  children?: React.ReactNode;
}

export const StartEndPopup = ({ times, driverName, isTrackingToday, children }: StartEndPopupProps) => {
  const addressWebData = useSelector(selectAddress);
  const { start, end } = times;

  const address = isWebDataSuccess(addressWebData) ? addressWebData.data : <TrackingPopUpSkeleton />;

  const getContent = () => {
    if (end && isTrackingToday) {
      return {
        title: 'Trajeto em andamento',
      };
    }

    return end ? { title: 'Fim do trajeto', icon: <EndIconComponent /> } : { title: 'Início do trajeto', icon: <StartIconComponent /> };
  };

  const content = getContent();

  return (
    <TrackingPopUp>
      <TrackingPopUpHeader>
        <TrackingPopUpHeaderMain>
          {content.icon}
          <TrackingPopUpTitle>{content.title}</TrackingPopUpTitle>
        </TrackingPopUpHeaderMain>
        {isTrackingToday && <OngoingRouteBadge />}
      </TrackingPopUpHeader>

      <TrackingPopUpContent>
        {start && <TrackingPopUpInfoRowText title='Início'>{formatTimestamp(start)}</TrackingPopUpInfoRowText>}
        {end && <TrackingPopUpInfoRowText title='Última atualização'>{formatTimestamp(end)}</TrackingPopUpInfoRowText>}
        <TrackingPopUpInfoRowText title='Endereço'>{address}</TrackingPopUpInfoRowText>
        <TrackingPopUpInfoRowText title='Motorista'>{driverName || 'Sem motorista'}</TrackingPopUpInfoRowText>
      </TrackingPopUpContent>

      <TrackingPopUpFooter>{children}</TrackingPopUpFooter>
    </TrackingPopUp>
  );
};
